import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { MembersService } from 'src/app/members/members.service';
import { SectorService } from 'src/app/sector/sector.service';
import { User } from 'src/app/shared/interfaces/user.interface';
import { GroupService } from '../group.service';

@Component({
  selector: 'app-group-form',
  templateUrl: './group-form.component.html',
  styleUrls: ['./group-form.component.css'],
})
export class GroupFormComponent implements OnInit {
  form: FormGroup;
  sectores = [];
  id = null;
  functions = [];
  members: User[] = [];

  constructor(
    private sectorService: SectorService,
    private toastr: ToastrService,
    private groupService: GroupService,
    private router: Router,
    private activeRouter: ActivatedRoute,
    private memberService: MembersService
  ) {
    this.getSectors();
    this.getMembers();
    this.activeRouter.params.subscribe((params) => {
      if (params.id) {
        this.id = params.id;
        this.loadGroup();
      }
    });
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      sector_id: new FormControl('', [Validators.required]),
      hour: new FormControl('', []),
      day: new FormControl('', []),
    });
  }

  loadGroup(): Promise<any> {
    return this.groupService
      .getById(this.id)
      .then((res) => {
        this.form.setValue({
          name: res.name,
          sector_id: res.sector_id,
          hour: res.hour,
          day: res.day,
        });
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu!');
      });
  }

  getSectors(): Promise<any> {
    return this.sectorService
      .get()
      .then((res) => {
        this.sectores = res;
      })
      .catch((err) => {
        this.toastr.error(err.messgae || 'algo de errado aconteceu!');
      });
  }

  save(): Promise<any> {
    return this.groupService
      .updateGroup(this.form.value, this.id)
      .then((res) => {
        this.toastr.success('Célula alterada com sucesso!');
        this.router.navigateByUrl('/celula');
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu');
      });
  }

  add(): Promise<any> {
    if (!this.form.valid) {
      this.form.errors;
      return;
    }
    let group = this.form.value;
    return this.groupService
      .addGroup(group)
      .then((res) => {
        this.toastr.success(res.message);
        this.router.navigateByUrl('/celula');
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Algo de errado aconteceu');
      });
  }

  getMembers(): Promise<any> {
    return this.memberService
      .get()
      .then((res) => {
        this.members = res;
      })
      .catch((err) => {
        this.toastr.error(err.messsage || 'Falha ao carregar membros!');
      });
  }
}
